export const enPublishedApps = {
  title: "Apps",
  subtitle: "Access your analytics tools and insights",
  empty: "No published apps yet.",
  errors: {
    loadFailed: "Could not load apps. Please try again.",
  },
  search: {
    placeholder: "Search apps...",
    ariaLabel: "Search apps",
    empty: "No apps match your search.",
  },
  favorites: {
    title: "Favorites",
  },
  favorite: {
    addAriaLabel: "Add to favorites",
    removeAriaLabel: "Remove from favorites",
  },
  section: {
    toggleAriaLabel: "Toggle {{title}} section",
  },
  list: {
    ariaLabel: "Published apps",
    unknownCategory: "Uncategorized",
  },
  view: {
    header: "{{name}}",
    backAria: "Back to Apps",
    loadingAria: "Loading app",
    notFound: "App not found.",
    errors: {
      loadFailed: "Could not load the app. Please try again.",
    },
    snapshot: {
      selectAria: "Choose a snapshot to view",
      live: "Live data",
    },
    items: {
      loadingAria: "Loading charts, tables, and KPI cards",
      streamingAria: "Loading more charts, tables, and KPI cards",
      empty: "This app has no charts, tables, or KPI cards yet.",
      emptyTab: "This tab has no charts, tables, or KPI cards yet.",
      noData: "No rows returned.",
      itemSummaryLabel: "AI summary",
      appSummaryLabel: "AI Overview",
      tabSummaryLabel: "Tab overview",
      // Screen readers only — the visible placeholder is an animated skeleton, so there is no
      // on-screen string to translate.
      summaryGeneratingAria: "Generating AI summary",
      drilldown: {
        openAria: "Show details for {{name}}",
        close: "Close details",
        filteredDialogTitle: "{{name}} · {{filter}}",
        loadFailed: "Could not load these details. Please try again.",
      },
      errors: {
        loadFailed: "Could not load charts, tables, and KPI cards. Please try again.",
      },
    },
  },
} as const;
